<template>
    <div class="retrieveBounced_app">
        <div class="retrieve_app">
            <el-input class="retrieveNum_app" v-model="input" placeholder="请输入内容..."></el-input>
            <el-button class="retrieve_btn_app" @click="retrieveBtnFun" type="danger"><i class="el-icon-search"></i></el-button>
        </div>
        
    </div>
</template>
<script>
import Bus from '@/Bus';

export default {
    data() {
        return {
            input: ''
        }
    },
    methods:{
        retrieveBtnFun(){    ///retrieveListTwo
            this.$router.push({path:'/retrieveList', query: {  keyWord: this.input }})
            this.input = ''
            Bus.$emit('stateListShoot',false);
        }
    }
}
</script>
<style lang="">
    .retrieve_app .el-input__inner{
        font-size:1rem !important;
    }
    .retrieveNum_app{
        font-size:1rem !important;
    }
    .retrieveBounced_app{
        width:100vw;
    }
    .retrieveBounced_app .retrieve_app{
        padding:0.4rem 0.6rem;
        display: flex;
        justify-content: center;
    }
    .retrieveBounced_app .retrieve_app .retrieve_btn_app{
        width:3rem;
        font-size:1.24rem;
        padding:0 !important;
        background:#C90304;
        border: 1px solid #C90304;
    }
    .retrieveBounced_app .retrieve_app .retrieve_btn_app i{
        font-size:1.24rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/appModule/bouncedMormApp/retrieveBounced.vue